import { createApp } from 'vue';
import toast from '@k90mirzaei/vue-toast';
import * as Sentry from '@sentry/vue';
import '@k90mirzaei/vue-toast/dist/index.css';
import infiniteScroll from 'vue-infinite-scroll';

import VueImageZoomer from 'vue-image-zoomer';
import 'vue-image-zoomer/dist/style.css';

import VueFilesPreview from 'vue-files-preview';
import 'vue-files-preview/lib/style.css';

import 'ag-grid-community/styles/ag-grid.min.css';
import 'ag-grid-community/styles/ag-theme-material.min.css';
import 'ag-grid-enterprise';

import App from '@/App.vue';
import { router } from '@/router';
import { store } from '@/store';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { sendMessage, sendRequest } from './service-worker-channel';

async function bootstrap() {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    await navigator.serviceWorker.getRegistrations()
      .then(regs => Promise.all(regs.map(r => r.unregister())));
    location.reload();
    return;
  } else if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then(regs => regs.forEach(r => r.unregister()));
  }

  window.addEventListener('beforeunload', () => {
    sendMessage({ type: 'bye' });
  });

  const app = createApp(App);
  // Sentry.init({
  //   app,
  //   dsn: process.env.VUE_APP_SENTRY_DSN,
  //   integrations: [new Sentry.BrowserTracing({ routingInstrumentation: Sentry.vueRouterInstrumentation(router) }), new Sentry.Replay()],
  //   tracesSampleRate: 1,
  //   replaysSessionSampleRate: 0.1,
  //   replaysOnErrorSampleRate: 1,
  // });
  app.use(store);
  app.use(router);
  app.use(toast);
  app.use(infiniteScroll);
  app.use(VueImageZoomer);
  app.use(VueFilesPreview);
  app.mount('#app');
}
bootstrap();
